import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Input from "../input";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import { createCouponCodeValidationSchema } from "@app/validations";
import Button from "../button";

function InputCouponModal({ portalDialogRef }: PortalDialogProps) {
  const onSubmit = (values: { couponCode: string }) => {
    portalDialogRef.close({ couponCode: values.couponCode });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="p-6 w-[380px] flex flex-col items-center">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-2xl">
          Mã ưu đãi
        </div>
        <div className="text-[#424E62] font-[SVN-Gilroy] font-medium mt-2 text-center">
          Hãy nhập mã ưu đãi.
        </div>
        <Formik
          initialValues={{
            couponCode: "",
          }}
          onSubmit={onSubmit}
          validationSchema={createCouponCodeValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <FormControl name="couponCode">
              <Input
                width={332}
                className="mt-5"
                placeholder="Nhập mã ưu đãi"
                inputClassName="font-[SVN-Gilroy] font-medium rounded-xl !text-[#272C36] tracking-[0.024px]"
                errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
              />
            </FormControl>
            <Button
              type="submit"
              containerClassName="mt-5 mx-auto"
              label="Xác nhận"
              labelClassName="font-[SVN-Gilroy] text-white font-bold text-base"
              width=""
              size="l"
              theme="none"
              className="text-lg font-bold px-11 !rounded-3xl bg-[linear-gradient(180deg,#5A82D7_-18.89%,#4667CA_141.11%)]"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default InputCouponModal;
